const timestamp2date = (ts) => new Date(Date.parse(ts))

module.exports = timestamp2date